import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Globe2, ChevronDown } from 'lucide-react';
import { MARKET_LINKS, SPECIALTY_LINKS } from '../../data/seoLinks';

const MarketsMenu = () => {
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const enter = () => { clearTimeout(timer.current); setOpen(true); };
  const leave = () => { timer.current = setTimeout(() => setOpen(false), 180); };

  return (
    <div className="relative" onMouseEnter={enter} onMouseLeave={leave}>
      <button data-testid="nav-markets-trigger" onClick={() => setOpen(o => !o)}
        className={`w-full inline-flex items-center justify-center gap-1.5 text-[10px] font-bold uppercase tracking-wider px-2 py-1.5 rounded border transition-colors ${open ? 'bg-green-700 text-white border-green-700' : 'bg-gray-100 text-[#0e1116] border-gray-300 hover:border-green-600 hover:text-green-700'}`}>
        <Globe2 className="w-3.5 h-3.5" /> Markets <ChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div data-testid="nav-markets-panel" onMouseEnter={enter} onMouseLeave={leave}
          className="absolute right-0 top-full mt-2 w-[min(640px,90vw)] bg-white border border-gray-200 rounded-lg shadow-2xl shadow-gray-400/30 p-5 animate-fadeIn z-50 normal-case text-left">
          <div className="grid grid-cols-2 gap-x-6">
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] font-black text-orange-500 mb-3">Countries We Serve</div>
              <div className="space-y-3">
                {MARKET_LINKS.map(l => (
                  <Link key={l.to} to={l.to} onClick={() => setOpen(false)} data-testid={`markets-link-${l.to.replace(/\//g, '')}`} className="block group">
                    <span className="text-[13px] font-bold text-gray-800 group-hover:text-green-700">{l.label}</span>
                    <p className="text-[10px] text-gray-500 mt-0.5 leading-snug">{l.headline}</p>
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] font-black text-orange-500 mb-3">Specialty Services</div>
              <div className="space-y-3 max-h-[380px] overflow-y-auto pr-1">
                {SPECIALTY_LINKS.map(l => (
                  <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block group">
                    <span className="text-[13px] font-bold text-gray-800 group-hover:text-green-700">{l.label}</span>
                    <p className="text-[10px] text-gray-500 mt-0.5 leading-snug">{l.headline}</p>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MarketsMenu;
